export var SmsUsageTriggerType;
(function (SmsUsageTriggerType) {
    SmsUsageTriggerType["AGE"] = "age";
    SmsUsageTriggerType["THRESHOLD"] = "threshold";
})(SmsUsageTriggerType || (SmsUsageTriggerType = {}));
//# sourceMappingURL=smsUsageInvoice.js.map